<template>
  <vx-card class="min-h-screen">
    <ResponseAlert ref="response" />
    <vs-row>
      <vs-col
        class="mt-5"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-w="12"
      >
        <vs-row class="justify-between" vs-type="flex" vs-w="12">
          <vs-col vs-lg="2" vs-sm="3" vs-xs="12">
            <vs-button
              :to="'/' + config.uri + '/add'"
              class="w-full"
              color="primary"
              type="filled"
              icon="add"
              >Add New</vs-button
            >
          </vs-col>
          <vs-col class="md:mt-0" vs-lg="8" vs-sm="8" vs-xs="12">
            <vs-row class="mb-5 mt-5 md:mt-0" vs-type="flex" vs-w="12">
              <vs-col vs-lg="2" vs-xs="12">
                <div class="w-full select-wrapper">
                  <select
                    class="w-full"
                    v-model="config.additional_params.isDraft"
                  >
                    <option
                      v-for="(status, index) in masters.statuses"
                      :key="index"
                      :value="status.value"
                    >
                      {{ status.text }}
                    </option>
                  </select>
                </div>
              </vs-col>
              <vs-col
                class="relative mt-2 md:mt-0 px-0 md:px-2"
                vs-lg="4"
                vs-xs="12"
              >
                <i
                  class="vs-icon notranslate icon-scale material-icons null absolute z-50"
                  style="top: 12px; right: 15px"
                  >search</i
                >
                <vs-input
                  class="w-full"
                  placeholder="Search"
                  v-model="config.search"
                  @input="handleSearch"
                />
              </vs-col>
              <vs-col class="mt-5 md:mt-0 lg:pr-2" vs-lg="4" vs-xs="12">
                <vs-button
                  class="w-full"
                  @click="models.advance_search = true"
                  color="primary"
                  type="filled"
                  >Advance Search</vs-button
                >
              </vs-col>
              <vs-col class="mt-3 md:mt-0" vs-lg="2" vs-md="6" vs-xs="12">
                <vs-button
                  @click="exportExcel"
                  class="w-full"
                  color="primary"
                  type="filled"
                  >Export</vs-button
                >
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row v-if="config.rows.length">
      <vs-col
        v-for="(campaign, index) in config.rows"
        :key="index"
        type="flex"
        vs-lg="4"
        vs-sm="6"
        vs-xs="12"
        class="p-2"
      >
        <CampaignCard @destroy="destroy" :campaign="campaign" />
      </vs-col>
    </vs-row>
    <vs-row v-else>
      <div class="w-full h-48 grid place-items-center">
        <p class="text-center">No campaign found</p>
      </div>
    </vs-row>

    <Pagination
      :config="config"
      @gotoPage="gotoPage"
      :initial="config.per_page"
    />

    <vs-popup
      button-close-hidden
      title="Search"
      :active.sync="models.advance_search"
    >
      <vs-row>
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="4" vs-xs="12">
          <label class="mb-1">Brand</label>
          <div class="w-full select-wrapper">
            <select class="w-full" v-model="config.additional_params.brandId">
              <option
                v-for="(brand, index) in masters.brands"
                :key="index"
                :value="brand.id"
              >
                {{ brand.name }}
              </option>
            </select>
          </div>
        </vs-col>
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="4" vs-xs="12">
          <label class="mb-1">Category</label>
          <div class="w-full select-wrapper">
            <select
              class="w-full"
              v-model="config.additional_params.categoryId"
            >
              <option
                v-for="(category, index) in masters.categories"
                :key="index"
                :value="category.id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>
        </vs-col>
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="4" vs-xs="12">
          <label class="mb-1">Type</label>
          <div class="w-full select-wrapper">
            <select
              class="w-full"
              v-model="config.additional_params.campaignTypeId"
            >
              <option
                v-for="(type, index) in masters.types"
                :key="index"
                :value="type.id"
              >
                {{ type.name }}
              </option>
            </select>
          </div>
        </vs-col>
      </vs-row>
      <vs-row class="my-5">
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="4" vs-xs="12">
          <label class="mb-1">Reward Type</label>
          <div class="w-full select-wrapper">
            <select
              class="w-full"
              v-model="config.additional_params.rewardType"
            >
              <option
                v-for="(status, index) in masters.rewards"
                :key="index"
                :value="status.value"
              >
                {{ status.text }}
              </option>
            </select>
          </div>
        </vs-col>
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="4" vs-xs="12">
          <label class="mb-1">Start date</label>
          <vs-input class="w-full" type="date" v-model="models.start_date" />
        </vs-col>
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="4" vs-xs="12">
          <label class="mb-1">End date</label>
          <vs-input
            v-validate="vars.endValidate"
            class="w-full"
            type="date"
            name="end date"
            v-model="models.end_date"
            :min="vars.end_date"
          />
          <span class="text-danger text-sm" v-show="errors.has('end date')">{{
            errors.first("end date")
          }}</span>
        </vs-col>
      </vs-row>
      <vs-row class="mt-10">
        <vs-col vs-type="flex" class="flex-col pr-1" vs-w="12" vs-lg="8">
          <vs-row>
            <vs-col vs-type="flex" vs-lg="4">
              <vs-button @click="advanceSearch" class="w-full" color="success"
                >Submit</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-lg="4" class="px-1">
              <vs-button @click="reset" class="w-full" color="warning"
                >Reset</vs-button
              >
            </vs-col>
            <vs-col vs-type="flex" vs-lg="4">
              <vs-button
                @click="models.advance_search = false"
                class="w-full"
                color="danger"
                >Cancel</vs-button
              >
            </vs-col>
          </vs-row>
        </vs-col>
      </vs-row>
    </vs-popup>
  </vx-card>
</template>

<script>
import moment from "moment";
import { getColorStatus } from "@/utils/helpers";
import api from "@/utils/api";
export default {
  name: "ListUser",
  data() {
    return {
      config: {
        uri: this.$route.meta.link,
        api: api.campaign,
        rows: [],
        total_data: 0,
        total_page: 0,
        per_page: 6,
        page: 1,
        orderby: "id",
        sort: "desc",
        additional_params: {
          isDraft: null,
          categoryId: null,
          rewardType: null,
          campaignTypeId: null,
          brandId: null,
          startDate: null,
          endDate: null,
        },
        search: "",
        debounce: null,
      },
      masters: {
        statuses: [
          { value: null, text: "Status" },
          { value: false, text: "Publish" },
          { value: true, text: "Draft" },
        ],
        brands: [{ id: null, name: "All Brands" }],
        categories: [{ id: null, name: "All Category" }],
        types: [{ id: null, name: "All Types" }],
        rewards: [
          { value: null, text: "All type" },
          { value: "1", text: "Cash" },
          { value: "2", text: "Loyalty" },
          { value: "3", text: "Gift" },
        ],
        platforms: [],
      },
      models: {
        advance_search: false,
        start_date: null,
        end_date: null,
      },
      vars: {
        onLoadData: false,
        end_date: moment().format("YYYY-MM-DD"),

        endValidate: "",
      },
      moment,
      getColorStatus,
    };
  },
  created() {
    const _ = this;
    _.vars.onLoadData = true;
    Promise.all([_.get(), _.getMasterOptions()]).then(() => {
      _.vars.onLoadData = false;
    });
  },
  methods: {
    get() {
      const pagination = JSON.parse(sessionStorage.getItem("db_currentPage"));
      if (pagination) {
        this.config.page = pagination.page;
      }
      this.$table.get(this.config);
    },
    gotoPage(page) {
      sessionStorage.setItem(
        "db_currentPage",
        JSON.stringify({
          route: "campaign",
          page,
        })
      );
      this.$table.gotoPage(this.config, page);
    },
    destroy(id) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Confirm",
        text: "Are you sure want to delete this data?",
        acceptText: "Yes",
        cancelText: "No",
        accept: () => {
          this.$axios
            .delete(`${api.campaign}/${id}`)
            .then((res) => {
              this.$refs.response.setResponse(res.data, "success");
              this.get();
            })
            .catch((error) =>
              this.$refs.response.setResponse(error.response.data, "danger")
            );
        },
      });
    },
    handleSearch() {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        sessionStorage.setItem("db_currentPage", 1)
        this.config.page = 1
        this.get();
      }, 300);
    },
    getMasterOptions() {
      const getTypes = this.$axios.get(api.misc_campaignTypes);
      const getCategories = this.$axios.get(api.misc_categories);
      const getBrands = this.$axios.get(api.misc_brands);
      const getTiers = this.$axios.get(api.mics_tiers);
      const getProducts = this.$axios.get(api.products);

      Promise.all([
        getTypes,
        getCategories,
        getBrands,
        getTiers,
        getProducts,
      ]).then((res) => {
        const masters = ["types", "categories", "brands"];
        masters.forEach((master, index) => {
          res[index].data.data.forEach((res) => {
            this.masters[master].push({
              id: res.id,
              name: res.name,
            });
          });
        });
      });
    },
    exportExcel() {
      const config = this.config;
      const additional_params = config.additional_params || {};
      const search = { search: config.search };
      this.$axios
        .get(`${api.campaign}/excel`, {
          params: Object.assign(search, additional_params),
          responseType: "blob",
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          const blob = new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
          });
          const aEle = document.createElement("a"); // Create a label
          const href = window.URL.createObjectURL(blob); // Create downloaded link
          aEle.href = href;
          aEle.download = `Report Campaign (${moment().format(
            "DD MMMM YYYY"
          )})`; // File name after download
          document.body.appendChild(aEle);
          aEle.click(); // Click to download
          document.body.removeChild(aEle); // Download complete remove element
          window.URL.revokeObjectURL(href); // Release blob object
        });
    },
    reset() {
      this.config.additional_params.categoryId = null;
      this.config.additional_params.rewardType = null;
      this.config.additional_params.campaignTypeId = null;
      this.config.additional_params.brandId = null;
      this.config.additional_params.startDate = null;
      this.config.additional_params.endDate = null;

      this.models.start_date = null;
      this.models.end_date = null;
      this.models.advance_search = false;
      this.get();
    },
    advanceSearch() {
      this.$validator.validate().then(async (valid) => {
        if (valid) {
          this.models.advance_search = false;
          if (this.models.start_date) {
            this.config.additional_params.startDate = moment(
              this.models.start_date
            ).format("YYYY-MM-DD");
            this.config.additional_params.endDate = moment(
              this.models.end_date
            ).format("YYYY-MM-DD");
          }
          this.get();
        }
      });
    },
  },
  computed: {
    status() {
      return this.config.additional_params.isDraft;
    },
    start_date() {
      return this.models.start_date;
    },
  },
  watch: {
    status() {
      this.get();
    },
    "config.per_page"() {
      sessionStorage.setItem("db_currentPage", 1)
      this.config.page = 1;
      this.get();
    },
    start_date() {
      if (!this.vars.onLoadData) {
        this.vars.end_date = moment(this.models.start_date).format(
          "YYYY-MM-DD"
        );
        if (moment(this.models.start_date).isAfter(this.models.end_date)) {
          this.models.end_date = moment(this.models.start_date).format(
            "YYYY-MM-DD"
          );
        }
        this.vars.endValidate = this.models.start_date ? "required" : "";
      }
    },
  },
};
</script>

<style></style>
